import React, { useContext } from 'react';
import { BaseAddonCategoryType, CreateMealXlsType, MealType } from 'utils/types';
import { BrandOption } from 'utils/types';

export type ImageDataType = {
  name: string;
  url: string;
};

type NewMealXlsContextType = {
  meals: any[];
  setMeals: (item: any[]) => void;
  mappedMeals: Partial<CreateMealXlsType[]>;
  setMappedMeals: (item: Partial<CreateMealXlsType[]>) => void;
  imageData: ImageDataType[];
  setImageData: (item: ImageDataType[]) => void;
  selectedBrand: BrandOption | undefined;
  setSelectedBrand: (item: BrandOption) => void;
  reviewedMeals: string[];
  setReviewedMeals: (item: string[]) => void;
  imageFiles: Array<File>;
  setImageFiles: (item: Array<File>) => void;
  xlsFile: File | null;
  setXlsFile: (item: File | null) => void;
  baseAddonCategories: BaseAddonCategoryType[];
  setBaseAddonCategories: (item: BaseAddonCategoryType[]) => void;
  baseMeals: MealType[];
  setBaseMeals: (item: MealType[]) => void;
};

export const NewMealXlsContext = React.createContext({} as NewMealXlsContextType);

const useNewMealXlsContext = () => {
  const context = useContext(NewMealXlsContext);
  return context;
};

export default useNewMealXlsContext;
